var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticStyle: { color: "red" } }, [
        _vm._v(
          "（优先级：临时活动 > 会员日优惠 > 会员群组优惠 > 普通会员优惠）"
        )
      ]),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "普通会员优惠", name: "StationDiscountBase" } },
            [
              _c(
                "keep-alive",
                [
                  _vm.activeName === "StationDiscountBase"
                    ? _c("StationDiscountBase")
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-tab-pane",
            {
              attrs: { label: "会员群组优惠", name: "StationDiscountGroupBase" }
            },
            [
              _c(
                "keep-alive",
                [
                  _vm.activeName === "StationDiscountGroupBase"
                    ? _c("StationDiscountGroupBase")
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "会员日优惠", name: "StationDiscountInterval" } },
            [
              _c(
                "keep-alive",
                [
                  _vm.activeName === "StationDiscountInterval"
                    ? _c("StationDiscountInterval")
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "临时活动", name: "StationDiscountActivity" } },
            [
              _c(
                "keep-alive",
                [
                  _vm.activeName === "StationDiscountActivity"
                    ? _c("StationDiscountActivity")
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }